import './sass/main.scss';
import './js/openModal';
import './js/events__modal';
import './js/footer';
import './js/pagination.js';
import './js/input.js';
import './js/loader.js';
import './js/timer';
import './js/buttonToTop';
